import { make } from 'vuex-pathify'

import dayjs from 'dayjs'
import isBetween from 'dayjs/plugin/isBetween'

dayjs.extend(isBetween)

const hours = {"from":"00:00","to":"24:00"}
const areas = {"Αθήνα":[10431,10432,10433,10434,10435,10436,10437,10438,10439,10440,10441,10442,10443,10444,10445,10446,10447,10551,10552,10553,10554,10555,10556,10557,10558,10559,10560,10561,10562,10563,10564,10671,10672,10673,10674,10675,10676,10677,10678,10679,10680,10681,10682,10683,11141,11142,11143,11144,11145,11251,11252,11253,11254,11255,11256,11257,11361,11362,11363,11364,11471,11472,11473,11474,11475,11476,11521,11522,11523,11524,11525,11526,11527,11528,11631,11632,11633,11634,11635,11636,11741,11742,11743,11744,11745,11851,11852,11853,11854,11855,16121],"Πειραιάς":[18531,18532,18533,18534,18535,18536,18537,18538,18539,18540,18541,18542,18543,18544,18545,18546,18547],"Χαλάνδρι":[15231,15232,15233,15234,15235,15238],"Γαλάτσι":[11146,11147],"Περιστέρι":[12131,12132,12133,12134,12135,12136,12137],"Αιγάλεω":[12241,12242,12243,12244],"Αγία Βαρβάρα":[12351],"Χαϊδάρι":[12461,12461,12462],"Ίλιον":[13121,13122,13123],"Πετρούπολη":[13231],"Άνω Λιόσια":[13341,13342,13343,13344,13345],"Καματερό":[13451],"Ζεφύρι":[13501],"Άγιοι Ανάργυροι":[13561,13562],"Αχαρνές":[13671,13672,13673,13674,13675,13677],"Θρακομακεδόνες":[13676],"Ηράκλειο":[14121,14122,14123],"Λυκόβρυση":[14123],"Νέα Ιωνία":[14231,14232,14233,14234,14235],"Νέα Φιλαδέλφεια":[14341,14342],"Νέα Χαλκηδόνα":[14343],"Μεταμόρφωση":[14451,14452],"Κηφισιά":[14561,14562,14563,14564],"Άγιος Στέφανος":[14565],"Πολιτεία":[14565],"Κρυονέρι":[14568,14569],"Άνοιξη":[14569],"Δροσιά":[14572],"Ροδόπολη":[14574],"Σταμάτα":[14575],"Διόνυσος":[14576],"Εκάλη":[14578,14671],"Νέα Ερυθραία":[14671],"Πεύκη":[15121],"Μαρούσι":[15122,15123,15124,15125,15126],"Μελίσσια":[15127],"Βριλήσσια":[15235],"Νέα Πεντέλη":[15236],"Πεντέλη":[15236],"Φιλοθέη":[15237],"Ψυχικό":[15237,15452],"Αγία Παρασκευή":[15341,15342,15343],"Ανθούσα":[15344,15349],"Γέρακας":[15344,16344],"Γλυκά Νερα":[15344,15354],"Παλλήνη":[15344,15351],"Σταυρός":[15344,15349],"Νέο Ψυχικό":[15451],"Χολαργός":[15561,15562],"Παπάγος":[15669],"Ζωγράφος":[15771,15772,15773],"Καισαριανή":[16121,16122],"Βύρωνας":[16231,16232,16233],"Ηλιούπολη":[16341,16342,16343,16344,16345,16346],"Αργυρούπολη":[16451,16452],"Γλυφάδα":[16561,16562,16672,16674,16675,16777],"Βουλιαγμένη":[16671],"Βάρη":[16672],"Βούλα":[16673],"Ελληνικό":[16777],"Νέα Σμύρνη":[17121,17122,17123,17124],"Δάφνη":[17234,17235,17236,17237],"Υμηττός":[17236,17237],"Άγιος Δημήτριος":[17236,17341,17342,17343],"Άλιμος":[17455,17456,17655],"Παλαιό Φάληρο":[17561,17562,17563,17564],"Καλλιθέα":[17671,17672,17673,17674,17675,17676],"Ταύρος":[17778],"Κορυδαλλός":[18120,18121,18122],"Άγ. Ιωάννης Ρέντης":[18233],"Μοσχάτο":[18344,18345,18346],"Νίκαια":[18450,18451,18452,18453,18454],"Δραπετσώνα":[18648],"Κερατσίνι":[18755,18756,18757,18758],"Πέραμα":[18863],"Κερατέα":[19001],"Παιανία":[19002],"Μαρκόπουλο":[19003],"Σπάτα":[19004],"Νέα Μάκρη":[19005],"Νέα Πέραμος":[19006],"Μαραθώνας":[19007],"Ραφήνα":[19009],"Καλύβια Θορικού":[19010],"Ανάβυσσος":[19013],"Καπανδρίτι":[19014],"Αρτέμιδα":[19016],"Ελευσίνα":[19200],"Ασπρόπυργος":[19300],"Κορωπί":[19400],"Λαύριο":[19500],"Μάνδρα":[19600]}

const codes = Object.values(areas)
  .reduce((all, item) => [...all, ...item], [])
  .map(code => code.toString())

const validPostalCode = (state) => {
  const code = state.postalCode || ''
  return codes.length ? codes.includes(code) : code.length == 5
}

const validAreas = () => {
  return Object.keys(areas)
}

const cityName = (state) => {
  return areas[state.postalCode]
}

const addTime = (date, time) => {
  const [hour, min] = time.split(':')
  return date.hour(hour).minute(min).second(0)
}

const storeOpen = () => {
  const now = dayjs()
  const from = addTime(now, hours.from)
  const to = addTime(now, hours.to)

  return now.isBetween(from, to, 'minute', '[]')
}

const acceptOrders = () => {
  return false
}

const canCheckout = () => {
  return acceptOrders() && storeOpen()
}

const openFrom = () => hours.from
const openTo = () => hours.to

const state = () => ({
  address: null,
  postalCode: null
})

const actions   = make.actions(state)
const mutations = make.mutations(state)
const getters   = {
  validPostalCode,
  storeOpen,
  acceptOrders,
  canCheckout,
  validAreas,
  cityName,
  openFrom,
  openTo,
  ...make.getters(state)
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}
